import React, { forwardRef } from 'react'

import Indicator from '../Indicator'
import { RadioIndicatorProps } from '../interfaces'

const RadioIndicator: React.ForwardRefRenderFunction<HTMLInputElement, RadioIndicatorProps> = (
  props,
  ref,
) => {
  return <Indicator type="radio" ref={ref} {...props} />
}

export default forwardRef(RadioIndicator)
